<template>
    <div>
        <p class="text-sm" :class="{ 'text-md': parent }">{{ child.name }}</p>
        <div v-if="parent" class="bars">
            <div v-for="(brand) in doc.local.priorities" :key="`key-${col}-${brand}`" class="label">
                {{ brand }}
            </div>
        </div>
        <div class="block">
            <div class="bars">
                <div v-for="(item, c) in extractSlots(child.phases)" :key="`slices-${col}-${child.id}-${c}`"
                    class="slice" :style="{ background: item.colour }">
                    <span>{{ item.brand }}</span>
                </div>
            </div>
        </div>
        <slot></slot>
    </div>
</template>


<script>

export default {
    name: "RollOutRow",
    data() {
        return {
        };
    },
    props: {
        col: String,
        doc: Object,
        child: Object,
        parent: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        extractSlots(phases) {
            console.log('phases', phases)
            let currentBrand = ''
            const palette = ['rgb(238 158 104)', 'rgb(106 164 220)', '#8c8c8c', '#afafaf', 'rgb(141 172 177)', '#CCCCCC', '#d8b39a']
            const cols = this.doc.local.priorities
            const brands = this.doc.local.brand
            const brandsObj = brands.map((x, index) => ({
                name: x,
                colour: palette[index]
            }))
            const getColor = (id) => {
                const item = brandsObj.find((x) => x.name === id)
                return item ? item.colour : ''
            }
            const arr = []
            cols.forEach((col) => {
                if (phases) {
                    const pick = phases.find((x) => x.col1 === col)
                    console.log('pick', pick)
                    currentBrand = pick ? pick.col2 : currentBrand
                }
                arr.push({
                    phase: col,
                    brand: currentBrand,
                    colour: getColor(currentBrand)
                })
            })
            return arr
        }
    }
}
</script>
